/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";
import {FormControl, FormGroup} from "@angular/forms";
import { customRequiredValidation } from "@irian-ro/shared-components-module";

export class ShipmentStatusChangeDtoModel extends JSONable {

  shipmentUuid: string | undefined = undefined;
  status: string | undefined = undefined;
  comments: string | undefined = undefined;
  actionedByUser: string | undefined = undefined;
  achievedAt: string | undefined = undefined;

  static createForm() {
    return new FormGroup({
      shipmentUuid: new FormControl(null, customRequiredValidation('shipmentUuid')),
      status: new FormControl(null, customRequiredValidation('status')),
      comments: new FormControl(),
      actionedByUser: new FormControl(),
      achievedAt: new FormControl(),
    })
  }

}
